import { render, staticRenderFns } from "./Terms.html?vue&type=template&id=e342adf8&scoped=true&"
import script from "./Terms.ts?vue&type=script&lang=ts&"
export * from "./Terms.ts?vue&type=script&lang=ts&"
import style0 from "./Terms.css?vue&type=style&index=0&id=e342adf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e342adf8",
  null
  
)

export default component.exports